export default{
  "en": {
    "dxCollectionWidget-noDataText": "No data to display",
    "dxList-pullingDownText": "Pull down to refresh...",
    "dxList-pulledDownText": "Release to refresh...",
    "dxList-refreshingText": "Refreshing...",
    "dxList-pageLoadingText": "Loading...",
    "dxList-nextButtonText": "More",
    "dxList-selectAll": "Select All",
    "dxListEditDecorator-delete": "Delete",
    "dxListEditDecorator-more": "More",
    "dxDataGrid-headerFilterOK": "Apply",
    "dxDataGrid-headerFilterCancel": "Close",
    "dxDataGrid-ascendingText":"Ascending order",
    "OK": "OK", 
    "Cancel": "Cancel",
    "dxPager-infoText": "Page {0} of {1} ({2} items)",
  },
  "ar": {
    "dxCollectionWidget-noDataText": "لا توجد بيانات للعرض",
    "dxList-selectAll": "اختيار الكل",
    "dxDataGrid-headerFilterOK": "حسنًا",
    "dxDataGrid-headerFilterCancel": "إلغاء",
    "dxDataGrid-sortingAscendingText": "فرز تصاعدي",
    "dxDataGrid-sortingDescendingText": "فرز تنازلي",
    "dxDataGrid-sortingClearText": "مسح الفرز",
    "OK": "تأكيد", 
    "Cancel": "إلغاء",
    "dxPager-infoText": "الصفحة {0} من {1} ({2} من العناصر)",
  },
  "es": {
    "dxCollectionWidget-noDataText": "No hay datos para mostrar",
    "dxList-selectAll": "Seleccionar todo",
    "dxDataGrid-headerFilterOK": "Aceptar",
    "dxDataGrid-headerFilterCancel": "Cancelar",
    "dxDataGrid-sortingAscendingText": "Orden Ascendente",
    "dxDataGrid-sortingDescendingText": "Orden Descendente",
    "dxDataGrid-sortingClearText": "Limpiar Ordenamiento",
    "dxPager-infoText": "Página {0} de {1} ({2} ítems)",
  }
}
